/* global API_ROOT */
/* eslint-disable import/prefer-default-export */
import {
  setElementToScroll,
  setPendingScroll,
  unsetPendingScroll
} from 'reduxModules/app'
import { scroller } from 'react-scroll'
import { push } from 'react-router-redux'
import {
  blogPostsFetch,
  blogPostFetch,
  blogPostCategoriesFetch,
  clearBlog,
  setFilterList,
  loadFilterList,
  clearFilterList,
  toggleFilters,
  types
} from './'

import {
  displayDialogAction,
  hideDialogAction,
  resetDialogAction
} from '../leadMagnetPages'

import { facebookReparse } from '../../../components/utils/facebookUtils'
import { adBannersFetch } from '../banners'
import { assetsFetch } from '../assets'

export const blogPostsMergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps
  return {
    ...stateProps,
    ...ownProps,
    loadBlogPosts(filters) {
      dispatch(blogPostsFetch(filters)()).then(([_, res]) => {
        if (res.type === types.BLOG_POSTS_FETCH_SUCCESS) {
          const { posts } = stateProps.pendingBackScroll
          const { isPending, element } = posts
          if (isPending) {
            scroller.scrollTo(element.name, {
              smooth: false,
              offset: -400
            })
            dispatch(unsetPendingScroll({ group: 'posts' }))
          }
        }
        facebookReparse()
      })
    },
    loadBlogCategories() {
      dispatch(blogPostCategoriesFetch()())
    },
    setFilters(filters) {
      dispatch(loadFilterList())
      dispatch(setFilterList(filters))
    },
    clearFilters() {
      dispatch(clearFilterList())
    },
    toggleFilters() {
      dispatch(toggleFilters())
    },
    setScrollingBackElement(payload) {
      dispatch(setElementToScroll(payload))
    }
  }
}

export const blogPostDispatchers = (dispatch, props) => ({
  loadBlogPostDetail() {
    dispatch(blogPostFetch(props.params.postSlug)()).then(([_, res]) => {
      if (res.payload.status === 404) dispatch(push('/404'))
      else dispatch(assetsFetch('post', res.payload.id, 50)())
    })
  },
  clearBlog() {
    dispatch(clearBlog())
  },
  loadAdBanners(filters) {
    dispatch(adBannersFetch(filters)())
  },
  triggerPendingScroll() {
    dispatch(setPendingScroll({ group: 'posts' }))
  },
  displayLeadMagnetDialog() {
    dispatch(displayDialogAction())
  },
  hideLeadMagnetDialog() {
    dispatch(hideDialogAction())
  },
  resetLeadMagnetDialog() {
    dispatch(resetDialogAction())
  }
})

export const relatedBlogPostDispatchers = dispatch => ({
  loadRelatedBlogPosts(author) {
    dispatch(blogPostsFetch({ author })())
  }
})
